@use 'themes/westfield' as *;
@use 'tools/fonts' as *;
@use 'tools/color' as *;
@use 'tools/dirg' as *;
@use 'tools/dirg-breakpoint' as *;

@import '../../../scentregroup-ui/tools/reset.css';

@mixin inlineLinkRow {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 48px;
  gap: 8px;

  a {
    height: 48px;
    line-height: 48px;
    vertical-align: middle;
    display: inline-block;
  }
}

:global {
  body {
    @include ceraPro;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
}

.terms {
  margin-top: units(1.5);

  &,
  a {
    color: #1c1f24;
  }
}

.createPasswordButtonRow {
  @include inlineLinkRow;
  margin-bottom: units(1.5);
  color: #1c1f24;
}

.submitButtonWrapper {
  display: flex;
  flex-flow: column;
}

.submitButton {
  flex-grow: 1;
}

.signUp {
  &,
  a {
    color: #1c1f24;
  }
}

// TODO: revisit when universal-login is in the monorepo or when
// the UI package starts supporting releases again, as this has
// been fixed there.
// See https://github.com/ScentreGroup/website_client/pull/2818
.passwordField button {
  top: -35px; // in pixels because it is manually fine-tuned
  display: flex;
  outline-offset: 2px;

  // ensure hide password icon uses the right color
  g {
    fill: inherit;
  }
}

.passwordField label,
.emailField label {
  font-weight: normal;
}

.forgotPasswordSection {
  @include inlineLinkRow;
  margin-bottom: units(1.5);
}

.forgotPasswordLink {
  color: #1c1f24;
}

.signUpText {
  @include inlineLinkRow;
  color: #1c1f24;
  margin-bottom: units(1.5);
}

.intro {
  padding: units(1) 0 units(1.5);
  border-top: #a2a2a9 solid 1px;
  color: #1c1f24;

  @include fromBreakpoint(tablet) {
    padding: units(1.5) 0;
  }
}

.socialButtons {
  border-top: #a2a2a9 solid 1px;
}
